
/**
 *
 * runs a task defined in workers/index.js and returns a promise of its completion
 *
 * @param taskName - constant from taskNames.js
 * @param ...args - arguments to pass to the function
 * @returns {Promise} - first message posted by worker
 */
export function runTask(taskName, ...args) {

  return import("worker-loader?inline=fallback!./index").then(Worker => {
    const w = new Worker();

    const p = new Promise((resolve, reject) => {
      const done = event => {
        resolve(event.data)
        w.removeEventListener('message', done)
      }
      w.addEventListener('message', done)
    })
    // console.debug('post message', taskName, args)
    w.postMessage({
      taskName,
      args
    })
    return p
  })
}
